export default __webpack_public_path__ + "static/media/chatbot-icon.c5b773a5.svg";